// extracted by mini-css-extract-plugin
export default {"checkboxes":"Confirmation_checkboxes__7uaiW"};